import React from "react"

import ic_logo from "../assets/ic_logo.png"

export class Logo extends React.PureComponent<React.ImgHTMLAttributes<HTMLImageElement>> {
    render() {
        return <img src={ic_logo} alt="ic_logo" className={`bg-white mb-4 mx-auto d-block img-thumbnail rounded card-img ${this.props.className}`} data-holder-renderered={true} style={{ width: 250, height: 250, objectFit: "contain", ...this.props.style }} />
    }
}